// src/pages/AccountDeactivatedPage.js
import React from 'react';
import { Box, Paper, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { LockPerson } from '@mui/icons-material';

const AccountDeactivatedPage = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                bgcolor: 'grey.100',
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        textAlign: 'center',
                        borderRadius: 4,
                    }}
                >
                    <LockPerson sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                    <Typography variant="h4" fontWeight={700} gutterBottom>
                        Acesso Restrito
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        Sua conta foi desativada e não possui mais acesso à plataforma.
                        Se você acredita que isso é um erro, por favor, entre em contato com o administrador da sua organização.
                    </Typography>
                    <Button
                        component={Link}
                        to="/login"
                        variant="contained"
                    >
                        Voltar para o Login
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
};

export default AccountDeactivatedPage;
